export const SET_SUMMARY_RESPONSES = "setSummaryResponses";
export const SET_FULL_RESPONSES = "setFullResponses";

// For testing
export const REFRESH_STATE = "refreshState";
